export const allCookiesSetToValue = (value) => ({
    session: value,
    persistent: value,
    necessary: true,
    preferences: value,
    statistics: value,
    marketing: value,
    firstParty: value,
    thirdParty: value,
});
export const allPropsApproved = (props, consent) => {
    if (!consent)
        return false;
    if (!consent[props.duration])
        return false;
    if (!consent[props.provenance])
        return false;
    if (!consent[props.purpose])
        return false;
    return true;
};
//# sourceMappingURL=utils.js.map